import React from "react";
import { Button, TextField, IconButton, Typography } from "@material-ui/core";
import { Add as AddIcon, Delete } from "@material-ui/icons";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import CongresoRedesSocialesEditor from "./CongresoRedesSocialesEditor";
import CongresoSeccionAnchoGrillaEditor from "./CongresoSeccionAnchoGrillaEditor";
import { normalizeCongresoAnchoGrilla } from "./congresoAnchoGrilla";
import { withProgramaDiasSortedPorHora } from "./congresoHoraSort";

function emptyActividad() {
  return {
    hora: "",
    titulo: {},
    ponente: {},
    redesSociales: [],
    descripcion: {},
    sala: "",
    categoria: {},
    anchoGrilla: 100,
  };
}

function diaPillPreview(dia, index) {
  const e = dia.etiqueta || {};
  const t = (e.es || e.ca || e.en || "").trim();
  return t || `Día ${index + 1}`;
}

export default function CongresoProgramaCalendario({
  programaPorDias = [],
  onChange,
  readOnly = false,
}) {
  const diasList = () => programaPorDias || [];

  const persistSorted = (next) => {
    onChange(withProgramaDiasSortedPorHora(next));
  };

  const persistAsIs = (next) => {
    onChange(next);
  };

  const addDia = () => {
    persistSorted([...diasList(), { etiqueta: {}, actividades: [] }]);
  };

  const removeDia = (di) => {
    const n = [...diasList()];
    n.splice(di, 1);
    persistSorted(n);
  };

  const updateDiaEtiqueta = (di, lang, val) => {
    const n = [...diasList()];
    const row = n[di] || { etiqueta: {}, actividades: [] };
    n[di] = {
      ...row,
      etiqueta: { ...(row.etiqueta || {}), [lang]: val },
    };
    persistAsIs(n);
  };

  const addActividad = (di) => {
    const n = [...diasList()];
    const row = n[di] || { etiqueta: {}, actividades: [] };
    n[di] = {
      ...row,
      actividades: [
        ...(row.actividades || []),
        emptyActividad(),
      ],
    };
    persistSorted(n);
  };

  const removeActividad = (di, ai) => {
    const n = [...diasList()];
    const row = n[di];
    if (!row) {
      return;
    }
    const acts = [...(row.actividades || [])];
    acts.splice(ai, 1);
    n[di] = { ...row, actividades: acts };
    persistSorted(n);
  };

  const updateActividadStr = (di, ai, field, val) => {
    const n = [...diasList()];
    const row = n[di];
    if (!row) {
      return;
    }
    const acts = [...(row.actividades || [])];
    const a = acts[ai] || {};
    acts[ai] = { ...a, [field]: val };
    n[di] = { ...row, actividades: acts };
    if (field === "hora") persistAsIs(n);
    else persistSorted(n);
  };

  const sortActividadesDelDia = (di) => {
    const n = [...diasList()];
    const row = n[di];
    if (!row) return;
    persistSorted(n);
  };

  const updateActividadI18n = (di, ai, field, lang, val) => {
    const n = [...diasList()];
    const row = n[di];
    if (!row) {
      return;
    }
    const acts = [...(row.actividades || [])];
    const a = acts[ai] || {};
    acts[ai] = {
      ...a,
      [field]: { ...(a[field] || {}), [lang]: val },
    };
    n[di] = { ...row, actividades: acts };
    persistSorted(n);
  };

  const updateActividadRedes = (di, ai, redesSociales) => {
    const n = [...diasList()];
    const row = n[di];
    if (!row) return;
    const acts = [...(row.actividades || [])];
    const a = acts[ai] || emptyActividad();
    acts[ai] = { ...a, redesSociales: Array.isArray(redesSociales) ? redesSociales : [] };
    n[di] = { ...row, actividades: acts };
    persistSorted(n);
  };

  const updateActividadAnchoGrilla = (di, ai, v) => {
    const n = [...diasList()];
    const row = n[di];
    if (!row) return;
    const acts = [...(row.actividades || [])];
    const a = acts[ai] || emptyActividad();
    acts[ai] = { ...a, anchoGrilla: normalizeCongresoAnchoGrilla(v, 100) };
    n[di] = { ...row, actividades: acts };
    persistAsIs(n);
  };

  const renderDiasForLang = (lang) => (
    <div className="congreso-edicion-programa-panel">
      <Typography variant="body2" color="textSecondary" className="mb-3">
        Las actividades de cada día se ordenan automáticamente por la hora indicada.
      </Typography>
      <div className="congreso-edicion-programa-dias-grid">
        {diasList().map((dia, di) => (
          <div key={di} className="congreso-edicion-comite-card">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <span className="congreso-prog-dia-preview">{diaPillPreview(dia, di)}</span>
              <IconButton size="small" onClick={() => removeDia(di)} aria-label="Quitar día">
                <Delete fontSize="small" />
              </IconButton>
            </div>
            <TextField
              label="Texto del día"
              fullWidth
              variant="outlined"
              margin="dense"
              placeholder="Jueves 23"
              value={(dia.etiqueta && dia.etiqueta[lang]) || ""}
              onChange={(e) => updateDiaEtiqueta(di, lang, e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <div className="mt-2">
              {(dia.actividades || []).map((act, ai) => (
                <div
                  key={ai}
                  className="border rounded p-2 mb-2"
                  style={{ borderColor: "#e0e3e8" }}
                >
                  <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                    <TextField
                      label="Hora"
                      variant="outlined"
                      margin="dense"
                      style={{ width: 100 }}
                      placeholder="09:00"
                      value={act.hora || ""}
                      onChange={(e) =>
                        updateActividadStr(di, ai, "hora", e.target.value)
                      }
                      onBlur={() => sortActividadesDelDia(di)}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      label="Etiqueta"
                      variant="outlined"
                      margin="dense"
                      style={{ flex: "1 1 160px", minWidth: 0 }}
                      placeholder="PLENARIA"
                      value={(act.categoria && act.categoria[lang]) || ""}
                      onChange={(e) =>
                        updateActividadI18n(di, ai, "categoria", lang, e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <CongresoSeccionAnchoGrillaEditor
                    compact
                    label="Ancho de esta actividad en la web"
                    value={act.anchoGrilla ?? 100}
                    disabled={readOnly}
                    onChange={(v) => updateActividadAnchoGrilla(di, ai, v)}
                  />
                  <TextField
                    label="Título"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={(act.titulo && act.titulo[lang]) || ""}
                    onChange={(e) =>
                      updateActividadI18n(di, ai, "titulo", lang, e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    label="Ponente (opcional)"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    placeholder="Nombre y apellidos"
                    value={(act.ponente && act.ponente[lang]) || ""}
                    onChange={(e) =>
                      updateActividadI18n(di, ai, "ponente", lang, e.target.value)
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <CongresoRedesSocialesEditor
                    redesSociales={act.redesSociales || []}
                    onChange={(next) => updateActividadRedes(di, ai, next)}
                    className="mt-1"
                  />
                  <TextField
                    label="Descripción"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    multiline
                    minRows={2}
                    value={(act.descripcion && act.descripcion[lang]) || ""}
                    onChange={(e) =>
                      updateActividadI18n(
                        di,
                        ai,
                        "descripcion",
                        lang,
                        e.target.value
                      )
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                  <div className="d-flex justify-content-end mt-1">
                    <IconButton
                      size="small"
                      onClick={() => removeActividad(di, ai)}
                      aria-label="Quitar actividad"
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </div>
                </div>
              ))}
              <Button
                size="small"
                variant="outlined"
                onClick={() => addActividad(di)}
                className="congreso-edicion-btn-orange"
              >
                Añadir actividad
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {!diasList().length ? (
        <fieldset
          disabled={readOnly}
          style={{ border: "none", padding: 0, margin: 0, minWidth: 0 }}
        >
        <div className="congreso-prog-slots__empty">
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={addDia}
            className="congreso-edicion-btn-orange"
          >
            Añadir día
          </Button>
        </div>
        </fieldset>
      ) : (
        <>
          <MultilanguageTabBlock
            contentDisabled={readOnly}
            multilanguageTabContent={renderDiasForLang}
          />
          <fieldset
            disabled={readOnly}
            style={{ border: "none", padding: 0, margin: 0, minWidth: 0 }}
          >
          <div className="mt-2">
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={addDia}
              className="congreso-edicion-btn-orange"
            >
              Añadir día
            </Button>
          </div>
          </fieldset>
        </>
      )}
    </>
  );
}
